module.exports = __webpack_public_path__ + "img/benifits.f1116f2b.jpg";